/* src/app/components/controls/sem-search/sem-search.component.css */
.search-control-semantic .search-input {
  display: block !important;
  padding-left: 50px;
}
.search-items-semantic-response-text {
  padding: 30px;
}
.search-items-semantic-wrapper {
  white-space: pre-line;
  display: block;
  border: 1px solid #e7ebee !important;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  min-height: 500px;
  margin-left: 50px;
}
.semantic-search-label {
  font-weight: bold;
  margin-top: 20px;
  padding-left: 50px;
}
/*# sourceMappingURL=sem-search.component.css.map */
